import type { FC } from 'react';
import { Dialog, IconButton } from '@mui/material';
import { CloseIcon } from 'components/icons';
import Suggestion from './Suggestion';
import Container from 'components/container';

import { Body, Heading } from 'components/text';

import styles from './MobileSearchDialog.module.scss';
import { useSearchBarContext } from './context';
import TextInput from './TextInput';
import type { InspirationType } from 'types/types';

import Inspirations from './Inspirations';

type MobileSearchDialogProps = {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  resetInputField: (event: React.MouseEvent<HTMLElement>) => void;
  inspirationCategories: InspirationType[];
};

export const MobileSearchDialog: FC<MobileSearchDialogProps> = ({
  handleChange,
  resetInputField,
  inspirationCategories,
}) => {
  const { state, setState } = useSearchBarContext();

  const {
    showSearchSuggestions,
    searchInputValue,
    debouncedSearchInputValue,
    searchSuggestionList,
    noResultsFound,
  } = state;

  const handleRequestClose = () => {
    setState({
      showSearchSuggestions: false,
    });
  };

  const hasSuggestions = searchSuggestionList?.length > 0;

  return (
    <Dialog fullScreen open={showSearchSuggestions} disableRestoreFocus>
      <div className={styles.container}>
        <IconButton
          onClick={handleRequestClose}
          title="close"
          disableRipple
          className={styles.closeBtnContainer}
        >
          <CloseIcon />
        </IconButton>

        <Heading as="h5" mt="50px" align="center">
          Where are you going?
        </Heading>

        <TextInput
          value={searchInputValue}
          onChange={handleChange}
          resetInputField={resetInputField}
          className={styles.searchInput}
        />

        <div>
          {!hasSuggestions &&
            (noResultsFound ? (
              <Body className={styles.noResultFound}>
                Sorry, we could&apos;t find any results for{' '}
                <Body
                  color="black"
                  weight="demiBold"
                  className={styles.noResultFoundText}
                >
                  ‘{debouncedSearchInputValue}’
                </Body>
              </Body>
            ) : (
              <Inspirations inspirationCategories={inspirationCategories} />
            ))}
          {hasSuggestions && (
            <Container mt="40px">
              {searchSuggestionList?.map(searchSuggestion => {
                return (
                  <Suggestion
                    key={searchSuggestion.id}
                    suggestion={searchSuggestion}
                  />
                );
              })}
            </Container>
          )}
        </div>
      </div>
    </Dialog>
  );
};
